export { default, type InlineMessageProps } from './InlineMessage';
